export const movementColours = {

  // 1. GREEN - PUSH group
  "Bench Press": "#e8f7ee",
  "Overhead Press": "#e3f4e8",
  "Incline Bench Press": "#eef9f2",
  "Ez Extension": "#e6f7ea",

  // 2. ORANGE/RED -  PULL group
  "Bent Row": "#fdeceb",
  "Deadlift Shrug": "#fce0dc",
  "Upright Row": "#fbe4e2",
  "Ez Curl": "#f9dedd",

  // 3. PURPLE/BLUE - LEGS group
  "Squat": "#f1e9fb",
  "Leg Extension": "#ede4f7",
  "Leg Curl": "#efe7fa",
  "Calf Raise": "#e9e1f5",

  // 4. YELLOW - OTHER group
  "Wrist Curl": "#fff9e6",
  "Reverse Wrist Curl": "#fff4d9"

};

export const categoryColours = {

  "Push": "#c4e8d3",
  "Pull": "#f6c9c4",
  "Legs": "#d8c7f2",
  "Other": "#ffe7b3"
}